export default __webpack_public_path__ + "static/media/The-steak-factory.52b430f7.png";